import script from "./ProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileView.vue?vue&type=script&setup=true&lang=js"

import "./ProfileView.vue?vue&type=style&index=0&id=7b4f3aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b4f3aa4"]])

export default __exports__